import React from "react"

/**
 * GroupedJobServiceTooltip component displays a list of job services
 * with their values when hovering over a grouped job item.
 *
 * @param {Object} props
 * @param {Array} props.services - Array of job service objects in the group (should be pre-sorted by booking date)
 * @param {number} props.totalValue - Total value of all services in the group
 */
export default function GroupedJobServiceTooltip({ services = [], totalValue = 0 }) {
  if (!services || services.length === 0) {
    return null
  }

  // Get the shared address from the first service
  const sharedAddress = services[0]?.address || "No Address"

  // Handle icon click to navigate to detail page
  const handleIconClick = (jobDetailsLink, e) => {
    e.stopPropagation()
    if (jobDetailsLink) {
      window.open(jobDetailsLink, "_blank", "noopener,noreferrer")
    }
  }

  return (
    <div className="grouped-job-tooltip-content">
      <div className="tooltip-header">
        <div className="header-top">
          <strong>
            {services.length}
            {" "}
            Job Services
          </strong>
        </div>
        <div className="tooltip-address" title={sharedAddress}>
          {sharedAddress.length > 50 ? `${sharedAddress.substring(0, 50)}...` : sharedAddress}
        </div>
      </div>
      <div className="tooltip-services-list">
        {services.map((service, index) => {
          const jobNo = service.job_no || service.jobNo || ""
          const price = parseFloat(service.total_cost || service.totalCost || service.price) || 0
          const estimatedHours = parseFloat(service.estimated_hours || service.estimatedHours) || 0

          // Build job details link for each service in the tooltip
          const jobId = service.job_id || service.jobId
          const serviceId = service.id
          const jobDetailsLink = jobId && serviceId
            ? `/jobs/${jobId}/job_services/${serviceId}`
            : null

          return (
            <div key={service.id || index} className="tooltip-service-item">
              {jobNo && <span className="service-job-no">{jobNo}</span>}
              {estimatedHours > 0 && (
                <span className="service-hours">
                  {estimatedHours}
                  h
                </span>
              )}
              <span className="service-price">
                  $
                  {price.toFixed(0)}
                </span>
              {jobDetailsLink && (
                <span
                  className="service-detail-icon"
                  title="View job service details"
                  onClick={e => handleIconClick(jobDetailsLink, e)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault()
                      handleIconClick(jobDetailsLink, e)
                    }
                  }}>
                  <i className="bi bi-box-arrow-up-right" aria-label="View details" />
                </span>
              )}
            </div>
          )
        })}
      </div>
      <div className="tooltip-footer">
          <strong>
            Total: $
            {totalValue.toFixed(0)}
          </strong>
        </div>
    </div>
  )
}
